<template>
  <v-sheet
    :class="
      collapse ? 'hyperdrive-logo hyperdrive-logo-collapse' : 'hyperdrive-logo'
    "
    :color="color"
    :elevation="elevate ? 6 : 0"
    class="d-flex pa-4"
  >
    <img :src="hyperdriveLogo" alt="Hyperdrive logo" style="width: 100%" />
  </v-sheet>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useInternalUser } from '#root/lib/useInternalUser'
import hyperdriveLogo from '#root/assets/logos/hyperdrive.svg'

const { internalUser } = useInternalUser()
const color = ref('red')

onMounted(() => {
  if (internalUser.value) color.value = 'blue'
})

defineProps({
  collapse: {
    default: false,
    type: Boolean
  },
  elevate: {
    default: false,
    type: Boolean
  }
})
</script>

<style lang="scss">
@use '../settings';
@use 'sass:map';

.hyperdrive-logo {
  width: 150px;
  height: 150px;
  transition:
    width 0.26s,
    height 0.3s;

  @media #{map.get(settings.$display-breakpoints, 'sm-and-down')} {
    width: 113px;
    height: 113px;
  }
}
.hyperdrive-logo-collapse {
  width: 113px;
  height: 113px;
}
</style>
